import { Link } from "react-router-dom";
import styles from "./styles.module.css";

export const LegalMentions: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1>Mentions Légales</h1>
      <p className="update-date">Dernière mise à jour : 25/03/2025</p>

      <h2>1. Informations légales</h2>
      <p>
        Le présent site internet, accessible à l’adresse{" "}
        <a
          href="https://cardonize.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://cardonize.com
        </a>
        , est édité par :
      </p>
      <ul>
        <li>
          <strong>Nom de l'entreprise :</strong> François CHIV (Cardonize)
        </li>
        <li>
          <strong>Statut juridique :</strong> Auto-entrepreneur
        </li>
        <li>
          <strong>Adresse :</strong> 19, Avenue d’Italie, 75013 Paris
        </li>
        <li>
          <strong>Numéro SIRET :</strong> 938501673
        </li>
        <li>
          <strong>Numéro de TVA intracommunautaire :</strong> (à compléter)
        </li>
        <li>
          <strong>RCS / APE :</strong> (à compléter)
        </li>
        <li>
          <strong>Email :</strong>{" "}
          <a href="mailto:contact@cardonize.com">contact@cardonize.com</a>
        </li>
        <li>
          <strong>Directeur de la publication :</strong> François CHIV
        </li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>Le site est hébergé par :</p>
      <ul>
        <li>
          <strong>Cloudflare Inc</strong>
        </li>
        <li>Adresse : 101 Townsend St, San Francisco, CA 94107, USA</li>
        <li>Téléphone : +1 (888) 992-5283</li>
        <li>
          Site :{" "}
          <a
            href="https://www.cloudflare.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.cloudflare.com
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <strong>DigitalOcean, LLC</strong>
        </li>
        <li>
          Adresse : 101 Avenue of the Americas, 10th Floor, New York, NY 10013,
          USA
        </li>
        <li>Téléphone : +1 (844) 299-8283</li>
        <li>
          Site :{" "}
          <a
            href="https://www.digitalocean.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.digitalocean.com
          </a>
        </li>
      </ul>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        Tous les éléments du site cardonize.com (textes, images, logos,
        graphismes, vidéos, etc.) sont protégés par les lois françaises et
        internationales relatives à la propriété intellectuelle. Toute
        reproduction, même partielle, est interdite sans l'accord préalable de
        l'éditeur.
      </p>

      <h2>4. Données personnelles</h2>
      <p>
        Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 et au
        RGPD du 25 mai 2018, nous nous engageons à protéger les données
        personnelles des utilisateurs.
      </p>
      <p>
        Les données sont utilisées uniquement pour le paramétrage des profils
        utilisateurs, visibles par d'autres. Elles ne sont ni revendues ni
        utilisées à d'autres fins.
      </p>
      <p>
        Les utilisateurs disposent d’un droit d’accès, de rectification, de
        suppression et de portabilité de leurs données. Ils peuvent l’exercer
        via <a href="mailto:contact@cardonize.com">contact@cardonize.com</a>.
      </p>

      <h2>5. Responsabilité</h2>
      <p>
        Le site ne saurait être tenu responsable des erreurs ou
        dysfonctionnements des informations publiées. Les liens externes ne
        relèvent pas de sa responsabilité.
      </p>

      <h2>6. Cookies</h2>
      <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
        Politique de confidentialité (cookies)
      </Link>
      <h2>7. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes mentions légales sont soumises à la loi française. En cas
        de litige, les parties tenteront une résolution à l’amiable. À défaut,
        les tribunaux compétents du siège social de Cardonize seront saisis.
      </p>

      <h2>8. Modification des mentions légales</h2>
      <p>
        L'éditeur se réserve le droit de modifier les présentes mentions légales
        à tout moment. Les utilisateurs sont invités à les consulter
        régulièrement.
      </p>
    </div>
  );
};
